export const STATUS_OPTIONS = [
  { label: "Aperta", value: "Aperta" },
  { label: "Chiusa", value: "ChiusaPositivo" },
  { label: "In lavorazione", value: "InLavorazione" },
  { label: "In attesa", value: "InAttesa" },
];
